<div class="container">
  <div *ngIf="sipayStatus == sipayStatusEnum.success" class="row justify-content-center message-box _success">
    <div class="col-md-5">
      <div class="">
        <i class="fa fa-check-circle" aria-hidden="true"></i>
        <h2>Ödemeniz Gerçekleşti</h2>
        <p>
          Birazdan başvuru sayfanıza yönlendirileceksiniz.
          <br />
          Lütfen bekleyin.
        </p>
      </div>
    </div>
  </div>

  <div *ngIf="sipayStatus == sipayStatusEnum.cancel" class="row justify-content-center message-box _success _failed">
    <div class="col-md-5">
      <div class="">
        <i class="fa fa-times-circle" aria-hidden="true"></i>
        <h2>Ödemeniz Başarısız</h2>
        <p>
          Ödemeniz alınamadı. Lütfen kart bilgilerinizi kontrol edin ve tekrar deneyin.
          <br />
          Eğer sorun devam ederse, lütfen müşteri hizmetleri ile iletişime geçin.
        </p>
      </div>
    </div>
  </div>
</div>
